import { defineMessages } from 'react-intl'

export default defineMessages({
    MM: 'MM',
    YYYY: 'AAAA',
    DD: 'DD',
    date: 'Fecha',
})
